import React, { ReactElement } from 'react';
import './PickerCard.scss';

export interface PickerCardOption<K extends string = string> {
  key: K;
  icon: ReactElement;
  title: string;
  description: string;
  badge?: ReactElement;
}

interface PickerCardProps<K extends string = string> {
  option: PickerCardOption<K>;
  isSelected: boolean;
  isDisabled?: boolean;
  onClick: (key: K) => void;
}

const PickerCard = <K extends string = string>({
  option,
  isSelected,
  isDisabled = false,
  onClick,
}: PickerCardProps<K>): ReactElement => (
  <button
    type="button"
    className={`picker-card${isSelected ? ' picker-card--selected' : ''}`}
    onClick={() => onClick(option.key)}
    disabled={isDisabled}
  >
    <div className="picker-card__header">
      <div className="picker-card__icon">{option.icon}</div>
      {option.badge && (
        <div className="picker-card__badge">{option.badge}</div>
      )}
      <div
        className={`picker-card__radio${
          isSelected ? ' picker-card__radio--checked' : ''
        }`}
      />
    </div>
    <div className="picker-card__title">{option.title}</div>
    <div className="picker-card__description">{option.description}</div>
  </button>
);

export default PickerCard;
